import { Divider } from '@mui/material'
import React, { useContext } from 'react'
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage'
import { PrioridadComponent } from './PrioridadComponent'


export const TablaPrioridades = ({prioridades}) => {
  const {modalAgregaPrioridad, setModalAgregaPrioridad} = useContext(PrioridadesContext);
  console.log('prioridades recibidas en tabla', prioridades)

  return (
    <div
        style={{
            display:'column',
            maxWidth:700,
            marginTop:20,
            maxHeight:'60%',
            overflowY:'auto'
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row'
        }}
      >
        <div
          style={{
            fontSize:14,
            fontWeight:'bold'
          }}
        >
          Prioridades
        </div>
      </div>
      <Divider />
      {
        prioridades?.map(prioridad => (
          <PrioridadComponent prioridad={prioridad} />
        ))
      }
    </div>
  )
}
